/* src/app/order/components/order-pricing/pricing-summary/pricing-summary.style.scss */
.pricing-summary {
  display: flex;
  justify-content: space-between;
  flex-flow: row-reverse;
}
.pricing-summary .total-price {
  float: right;
  margin-bottom: 15px;
  text-align: right;
}
.pricing-summary .total-price .three-years-label {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
}
.pricing-summary .total-price .three-years-label label {
  display: block;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  color: #008238;
  margin-left: 10px;
}
.pricing-summary .total-price span {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: normal;
  color: #585858;
}
.pdf-download-box {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
@keyframes shine {
  0% {
    left: -75%;
  }
  60% {
    left: 125%;
  }
  100% {
    left: 125%;
  }
}
.pdf-download-box .summary-price-info {
  color: #007d40;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 0 0 0;
}
.pdf-download-box button.download-offer-pdf {
  min-width: 225px;
  max-width: 280px;
  height: 36px;
  background-color: #007d40;
  color: #ffffff;
  font-size: 15px;
  padding: 0 10px 0 10px;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.pdf-download-box button.download-offer-pdf #download-icon {
  margin-left: 10px;
}
.pdf-download-box button.download-offer-pdf :before {
  content: "";
  position: absolute;
  top: 0;
  left: -75%;
  width: 50%;
  height: 100%;
  background:
    linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.6),
      transparent);
  transform: skewX(-20deg);
  animation: shine 3s infinite;
}
.pdf-download-box button.download-offer-pdf :hover {
  transition: transform 0.2s;
}
.pdf-download-box button.download-offer-pdf-reviewer {
  min-width: 225px;
  max-width: 280px;
  height: 36px;
  background-color: #007d40;
  color: #ffffff;
  font-size: 15px;
  padding: 0 10px 0 10px;
  font-weight: bold;
}
.pdf-download-box button.download-offer-pdf-reviewer #download-icon {
  margin-left: 10px;
}
.pdf-download-box #download-offer-pdf-text {
  padding-top: 10px;
  text-align: right;
  color: #8C8C8C;
  font-size: 12px;
}
.pdf-download-box .additional-margin {
  margin-bottom: 20px;
}
#download-icon {
  margin-left: 0;
}
button:focus {
  color: #007d40 !important;
}
/*# sourceMappingURL=pricing-summary.style.css.map */
